import { StepBar } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

import { BREAKPOINT, DEVICE } from '@hero/constants';

const Layout = styled.div`
  background-color: var(--color-bg-weakest2);
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  width: 100%;

  ${StepBar.S.StepBar} {
    max-width: ${({ stepsLength = 3 }) => stepsLength * 134}px;
    width: 402px;

    ${DEVICE.mobile.max} {
      width: 100%;
    }
  }
`;

const LayoutHeader = styled.div`
  background-color: var(--color-bg-default);
  border: 1px solid var(--color-border-default);
  min-height: 90px;
  padding: 16px;
  width: 100%;

  ${DEVICE.mobile.max} {
    min-height: auto;
  }
`;

const LayoutHeaderContainer = styled.div`
  align-items: center;
  display: flex;
  flex-grow: 1;
  gap: 24px;
  height: 100%;
  justify-content: space-between;
  margin: 0 auto;
  max-width: ${BREAKPOINT.desktop.min}px;
  width: 100%;

  ${DEVICE.mobile.max} {
    flex-direction: column;
  }
`;

const LayoutBodyInner = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  margin: 0 auto;
  max-width: ${BREAKPOINT.desktop.min}px;
  min-height: fit-content;
  overflow-x: hidden;
  padding: 64px 0 32px;
  width: 100%;

  ${DEVICE.mobile.max} {
    padding: 16px;
  }
`;

const LayoutBody = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
`;

export { Layout, LayoutBody, LayoutBodyInner, LayoutHeader, LayoutHeaderContainer };
